import React, { FC } from 'react'
import { IFormItem, ISelectOption } from '../Types'
import { Form, Select, Tooltip } from 'antd'
import { CopyOutlined, ExclamationCircleOutlined, EyeOutlined } from '@ant-design/icons'

export const __FormSelect: FC<IFormItem> = ({ placeholder, fieldLabel, fieldName, selectMode, initWidth, ...props }) => {
    return (
        <Form.Item
            // label={fieldLabel}
            // label={<Tooltip title={title}>{fieldLabel}<CopyOutlined  style={{fontSize:'12px',color:"#4062d8"}}/></Tooltip>}
            label={props.detialVal ?
                <Tooltip title={props.detialVal}>{fieldLabel}
                    <CopyOutlined
                        style={{ fontSize: '13px', color: '#4062d8', marginLeft: '5px' }}
                        onClick={(e) => {
                            e.stopPropagation()
                            props?.copyText?.(fieldName, props.options)
                        }}
                    />
                    <EyeOutlined style={{ fontSize: '15px', color: '#4062d8', marginLeft: '5px' }} />
                </Tooltip> :
                props.waring ?
                    <span>
                        {fieldLabel}{' '}
                        <CopyOutlined
                            style={{ fontSize: '13px', color: '#4062d8' }}
                            onClick={(e) => {
                                e.stopPropagation()
                                props?.copyText?.(fieldName, props.options)
                            }}
                        />
                        <Tooltip title={props.waring}>
                            <ExclamationCircleOutlined style={{ fontSize: '17px', color: '#fb5430', marginLeft: '5px', cursor: 'pointer' }} />
                        </Tooltip>
                    </span>
                    :
                    <span>
                        {fieldLabel}{' '}
                        <CopyOutlined
                            style={{ fontSize: '13px', color: '#4062d8' }}
                            onClick={(e) => {
                                e.stopPropagation()
                                props?.copyText?.(fieldName, props.options)
                            }}
                        />
                    </span>
            }
            name={fieldName}
            rules={props.rules}
            labelCol={props.labelCol ?? { span: 24 }}
        >
            <Select
                mode={selectMode}
                // maxTagCount={1}
                placeholder={placeholder ? placeholder : typeof fieldLabel === 'string' ? fieldLabel : ''}
                showSearch={props.showSearch ?? true}
                optionFilterProp="label"
                style={{ width: initWidth ?? '100%' }}
                allowClear={props.allowClear}
                options={props.options?.filter(opt => !opt.disabled) /* 过滤disabled选项 */}
                disabled={props.disable}
                onChange={(value: string, option) => props.onSelectChange?.(value, option as ISelectOption)}
                onFocus={() => props.onSelectFocus?.()}
            />
        </Form.Item>
    )
}
